import React, { useState } from "react";
import styles from "./card-deck.module.css";
import { cardImages } from "../../images_data";
import { shuffle } from "lodash";
import { useDispatch } from "react-redux";
import { addMessage, setWaitingResponse } from "../../store/stateSlice";
import { Card } from "../card/card";

const CardDeckInput = ({ title }) => {
  const dispatch = useDispatch();

  const [hidden, setHidden] = useState(false);
  const [selected, setSelected] = useState(null);
  const [shuffledImages, _] = useState(shuffle(cardImages));

  const handleSelected = (id) => {
    if (selected) {
      return
    }
    
    setSelected(id);
    setTimeout(() => {
      setHidden(true);
      dispatch(addMessage(<Card image={shuffledImages[id]} />));
      dispatch(setWaitingResponse());
    }, 1000);
  };

  return (
    <div>
      <p>{title}</p>
      {!hidden && (
        <ul className={styles.cards_container}>
          {[...Array(10)].map((_, id) => (
            <li key={id} onClick={() => handleSelected(id)}>
              <div className={styles.card_background}></div>
              <div
                className={
                  selected === id
                    ? `${styles.card_front} ${styles.return_card}`
                    : styles.card_front
                }
              >
                {selected === id && <img src={shuffledImages[id]} alt="card" />}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export { CardDeckInput };
